/* eslint-disable complexity */
import React, { ReactElement } from 'react';
import { Field, useFormikContext } from 'formik';
import StandardFormField from '@ramsey-design-system/form-field';
import { useFieldValidation } from '../shared/hooks';
import { FormikFormFieldProps } from '../shared/types';

function FormikFormField<T = unknown>(
  props: FormikFormFieldProps<T>
): ReactElement {
  const formikContext = useFormikContext<T>();
  if (!formikContext) {
    console.warn(
      `[RT-PROTECTIONS-UI]: Formik context is undefined for the ${props.name.toString()} component. Please verify that a <Formik> component is wrapping your <FormikFormField> component at some level or remove your name and inputComponent properties.`
    );
  }

  const {
    name,
    inputComponent,
    formikAttributes,
    rdsAttributes,
    htmlAttributes,
    children,
    ...rest
  } = props;

  const { errorMessage, invalid } = useFieldValidation<T>(name);

  // Only checkboxes will have a boolean value
  const checkedProps =
    typeof formikContext.values[props.name] === 'boolean'
      ? { checked: formikContext.values[props.name] }
      : {};

  return (
    <StandardFormField
      invalid={invalid}
      errors={[errorMessage]}
      {...rdsAttributes}
      {...rest}
    >
      {({ invalid: fieldInvalid, ...formFieldProps }) => (
        <Field
          as={inputComponent}
          name={name}
          data-testid={props.id}
          {...checkedProps}
          {...formFieldProps}
          {...formikAttributes}
          {...htmlAttributes}
        >
          {/* Pass children in only for Selects */}
          {children}
        </Field>
      )}
    </StandardFormField>
  );
}

export { FormikFormField };
